import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GEO_INTENTS } from "@/data/geo-constants";
import { GeoIntent } from "@/lib/types";

type GeoIntentSelectProps = {
  value: GeoIntent | "";
  onChange: (value: GeoIntent) => void;
};

export function GeoIntentSelect({ value, onChange }: GeoIntentSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as GeoIntent)}>
      <SelectTrigger className="w-full bg-background/50 border-border/30">
        <SelectValue placeholder="Select intent..." />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border z-50">
        {GEO_INTENTS.map((intent) => (
          <SelectItem key={intent.value} value={intent.value}>
            <div className="flex flex-col">
              <span className="font-medium">{intent.label}</span>
              <span className="text-xs text-muted-foreground">{intent.description}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
